import { useEffect } from "react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { EVT_FLUSH_DONE, EVT_FAILED } from "@/lib/offlineQueue";

// Lot 630 — toasts du mode hors ligne : « Envoyé ✓ » quand la file est repartie au retour du réseau, erreur si le serveur refuse.
export const OfflineQueueBridge = () => {
  const { t } = useApp();
  useEffect(() => {
    const onDone = (e) => {
      const n = e?.detail?.sent || 0;
      if (!n) return;
      toast.success(n === 1 ? t("offline.sent_one", "Envoyé ✓ — ton action hors ligne est partie") : t("offline.sent_n", "{n} actions hors ligne envoyées ✓").replace("{n}", n), { id: "offline-sent" });
    };
    const onFailed = (e) => {
      const msg = e?.detail?.message;
      toast.error(t("offline.failed", "Une action hors ligne a été refusée") + (msg ? ` : ${msg}` : ""));
    };
    window.addEventListener(EVT_FLUSH_DONE, onDone);
    window.addEventListener(EVT_FAILED, onFailed);
    return () => { window.removeEventListener(EVT_FLUSH_DONE, onDone); window.removeEventListener(EVT_FAILED, onFailed); };
  }, [t]);
  return null;
};
